import React from 'react';
import { RotateCw, TriangleAlert } from 'lucide-react';
import { Button, EmptyState } from './ui';
import { AuthGround } from './auth/AuthLayout';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  handleRetry = (): void => {
    this.setState({ hasError: false, error: null });
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <AuthGround>
          <div className="ui-auth__card ui-auth__card--wide">
            <EmptyState
              icon={<TriangleAlert />}
              title="エラーが発生しました"
              description="予期しないエラーが発生しました。ページを再読み込みしてください。"
              action={
                <div className="ui-auth__actions">
                  <Button type="button" onClick={this.handleRetry}>
                    再試行
                  </Button>
                  <Button
                    type="button"
                    variant="primary"
                    iconLeft={<RotateCw aria-hidden="true" />}
                    onClick={() => window.location.reload()}
                  >
                    ページを再読み込み
                  </Button>
                </div>
              }
            />
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="ui-auth__detail">{this.state.error.toString()}</pre>
            )}
          </div>
        </AuthGround>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
